import { connect } from 'react-redux'
import { compose } from 'recompose'

import { makeHoverable } from 'components/Utils/hoverable'
import { providesUserPreferencesMutations } from 'components/Settings/User/dataSync'
import { selectors as UsersSelectors } from 'data/users'
import { createInfoToasterMessage } from 'data/ui/actions'

export default compose(
  providesUserPreferencesMutations,
  makeHoverable(),
  connect(
    state => ({
      canInvite: UsersSelectors.canCurrentUserInviteMembers(state),
      usersCount: UsersSelectors.getAllUsers(state, {
        filterOutArchived: true,
        filterOutInvited: true,
      }).size,
    }),
    { createInfoToasterMessage }
  )
)
